import React, {useState} from 'react';
import Modal from 'react-modal';
import '../../styles/partials/components/_modal.scss';
import FolderIcon from '../../images/folder.svg';
import {useLocation} from "react-router-dom";
import folders from "../../services/api/folders";
import ReactGA from 'react-ga';
import Plaudy from "plaudy";

const CreateFolderModal = ({ isOpen, closeModal }) => {
  const location = useLocation();
  let folder = location.pathname.replace('/', '');
  const [folderName, setFolderName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const maxLength = 40;

  Modal.setAppElement('#root');

  const createFolder = async () => {
    try {
      setIsLoading(true);
      const {data} = await folders.create({folderAbove: folder, name: folderName});
      const {id} = data;

      ReactGA.event({
        category: 'Usage',
        action: 'Created Folder',
      });
      Plaudy.track('create folder', {
        folderId: id,
        folderName: folderName,
        folderAbove: folder,
      });

      setError(null);
      setFolderName('');
      closeModal();
      window.location.href = `${id}`;
    } catch (e) {
      setError('') // TODO: Show error
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = async () => {
    // TODO: Cancel the request
    closeModal();
    setFolderName('');
  };

  const handleNameInputChange = e => {
    setFolderName(e.target.value);
  };

  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Create Folder Modal"
      onRequestClose={closeModal}
      className="modal"
      overlayClassName="modal-overlay"
    >
      <div className="modal-title">
        <img src={FolderIcon} alt="Folder" />
        <h2>Create folder</h2>
      </div>
      <div className="modal-body">
        <div className="form-row">
          <label>Name</label>
          <div className="input-wrapper">
            <input placeholder="Folder name" value={folderName} onChange={handleNameInputChange} maxLength={maxLength} />
            <span className="max-characters">{maxLength - folderName.length}</span>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <div className="button-group">
          <a className="button-secondary" onClick={handleCancel}>Cancel</a>
          <a className="button-primary" onClick={createFolder}>Create</a>
        </div>
      </div>
    </Modal>
  );
};

export default CreateFolderModal;
